import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {adminAction, GetMemberOfSubjectsAction} from '../action';

const tableId = 'memberOfSubjects';

function* execute({payload: {tableDataRequest, userProfileId}}: GetMemberOfSubjectsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getSubjectMembersPage,
        successAction: adminAction.getMemberOfSubjectsSuccess,
        tableId,
        pathParams: {
            userProfileId,
        },
    }));
}

/** Runs the admin saga that loads subject membership details for the current selection. */
export function* getMemberOfSubjectsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MEMBER_OF_SUBJECTS', execute);
}
